import $ from 'jquery';

const CATEGORIES = ['need', 'course', 'diet', 'length', 'more', 'flavor'];

export default class {
  constructor() {
    // dynamically adds buttons and modal props to class
    for (let i in CATEGORIES) {
      const category = CATEGORIES[i].charAt(0).toUpperCase() + CATEGORIES[i].slice(1);

      this[`filterPost${category}Button`] = null
      this[`filterPost${category}Modal`] = null
    }

    // adds apply button
    this.applyFilterTypeButton = null;

    this.init();
  }

  init() {
    
    // Prevent dropdown from closing on click inside
    $(document).on('click', '.dropdown-menu', function (e) {
      e.stopPropagation();
    });
    
    $('.facetwp-checkbox').on('click', function ( e ) {
        e.stopPropagation();
    });
    
    
    for (let i in CATEGORIES) {
      console.log(CATEGORIES[i]);
      const category = CATEGORIES[i].charAt(0).toUpperCase() + CATEGORIES[i].slice(1);

      // assign button to prop
      this[`filterPost${category}Button`] = $(`.filter-post-${CATEGORIES[i]}`);

      // assign modal to prop
      this[`filterPost${category}Modal`] = $(`#post${category}FilterModal`);

      // add button click handler
      this[`filterPost${category}Button`].on('click', () => {
        this.handleFilterButtonClick(this[`filterPost${category}Modal`], this[`filterPost${category}Button`])
      });
      
      // Prevent closing of dropdown if checkbox or dropdown itself is clicked
    //   $(`#post${category}FilterDropdown`).on('click', (e) => {
    //       e.stopPropagation();
    //   });
      
    //   $('.dropdown').on('hide.bs.dropdown', function (e) {
    //         var target = $(e.target);
    //         if(target.hasClass("keepopen") || target.parents(".keepopen").length){
    //             return false; // returning false should stop the dropdown from hiding.
    //         }else{
    //             return true;
    //         }
    //   });

      // checks status of button on hide
      $(`#post${category}FilterDropdown`).parent('div').on('hide.bs.dropdown', this.handleDropdownClose.bind(this))
      $(`#post${category}FilterDropdown`).parent('div').on('hide.bs.dropdown', this.hideDimmer)
      $(`#post${category}FilterDropdown`).parent('div').on('show.bs.dropdown', this.showDimmer)
      $(`#post${category}FilterDropdown`).parent('div').on('shown.bs.dropdown', this.showDimmer)
    }
    
    $('.btn-dropdown-toggle').on('click', function() {
        console.log($(this))
        if($(this).hasClass('active')) {
            $('.browse-header .dimmer').show();
            console.log('show')
        } else {
            $('.browse-header .dimmer').hide();
            console.log('hide')
        }
    });
    
    $('.dimmer').on('click', function() {
        $(this).hide();
    });

    this.applyFilterTypeButton = $('.apply-post-type-filter');
    this.applyFilterTypeButton.on('click', this.handleFilterTypeApply.bind(this));

  }
  
  showDimmer() {
       $('.browse-header .dimmer').show()
  }
  hideDimmer() {
       $('.browse-header .dimmer').hide()
  }

  /**
   * Event Handlers
   **/
  handleFilterButtonClick(modal, button) {
    modal.modal('show');
    button.addClass('active');
    // $('.browse-header .dimmer').show();
  }

  handleFilterTypeApply() {
    // find all selected checkboxes
    const selectedCheckboxes = [];

    $('input[type="checkbox"]')
      .each((_, el) => {
        if ($(el).is(':checked')) {
          selectedCheckboxes.push($(el));
        }
      });

    const nutritionalBenefits = [];
    const courses = [];
    const diets = [];
    const lengths = [];
    const themes = [];
    const ingredients = [];

    console.log($('#mealplanLength').text());


    lengths.push($('#mealplanLength').text()); 


    selectedCheckboxes.forEach(checkbox => {
      const value = checkbox.val();

      switch (checkbox.attr('name')) {
        case 'post-need':
          nutritionalBenefits.push(value);
          break;
        case 'post-course':
          courses.push(value);
          break;
        case 'post-diet':
          diets.push(value);
          break;
        case 'post-length':
          lengths.push(value);
          break;
        case 'post-global-theme':
          themes.push(value);
          break;
        case 'post-ingredient':
          ingredients.push(value);
          break;
        default:
          return;
      }
    });

    const params = {
      nutritionalBenefits,
      courses,
      diets,
      lengths,
      themes,
      ingredients,
    };
// 	console.log($.param(params));

 
    if ($('.meal-plan-filter-apply').length) {
      window.location.href = `../../browse/meal-plans/?${$.param(params)}`;
    } else {
      window.location.href = `../../browse/recipes/?${$.param(params)}`;
    }

    
  }
  

  handleDropdownClose(event) {
      
      console.log(event.relatedTarget);

    const target = event.relatedTarget.id
      .replace('post', '')
      .replace('MenuButton', '')
      .replace('Dropdown', '');
      

    const isChecked = $(`#post${target}Dropdown`)
      .children()
      .find('.facetwp-checkbox.checked').length > 0 ? true : false;

      console.log(event.relatedTarget.id);

    if (isChecked) {
      $(`#post${target}DropdownMenuButton`).addClass('active');
    //   $('.browse-header .dimmer').show()
      return;
    }
    $(`#post${target}DropdownMenuButton`).removeClass('active');

  }
}


// WEBPACK FOOTER //
// ./scripts/modules/FilterController.js